import React, { useState } from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { IndicatorDetailSectionProps } from './utils';
import IndicatorBottomButtons from './IndicatorBottomButtons';
import ShowGuidanceText from '../Review/ReportCustomQuestionType/ShowGuidanceText';
import { INDICATOR_DETAILS_QUESTION_ID } from '../../../NPOFeedback/utils';

const StyledDiv = styled.div`
  .heading-helper-text {
    margin-left: auto;
    margin-right: auto;
  }
`;

const IndicatorDetailsIntro: React.FC<IndicatorDetailSectionProps> = ({
  guidanceText,
  onNext,
  onPrevious,
}) => {
  return (
    <StyledDiv>
      <TrueImpactText variant="heading-page">
        Now let’s quantify all of the indicators in your model
      </TrueImpactText>
      <ShowGuidanceText
        questionId={INDICATOR_DETAILS_QUESTION_ID}
        guidanceText={guidanceText}
      />
      <TrueImpactText className="heading-helper-text" align="center">
        As you respond, we’ll show you above how this is reflected in each of
        your Impact Model stages.
      </TrueImpactText>
      <IndicatorBottomButtons
        requestState="init"
        previousButtonText="Previous Section"
        nextButtonText="Let’s go!"
        onNext={onNext}
        onPrevious={onPrevious}
      />
    </StyledDiv>
  );
};

export default IndicatorDetailsIntro;
